import { SupplierOrdersPageTab } from 'interfaces';

export const ALL_STATUSES_TAB_NAME: SupplierOrdersPageTab = 'ALL';
